import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslate();

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: t('nav.menu.superadmin.users'),
            path: paths.superadmin.users,
            icon: <Iconify icon="mdi:account-multiple" />,
          },
          {
            title: t('nav.menu.superadmin.entities'),
            path: paths.superadmin.entities,
            icon: <Iconify icon="mdi:domain" />,
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
